import history from '../../../../../core/history';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import {
  REMINDERS_ACTION,
  REMINDERS_REDIRECT_FROM_SMS,
  REMINDERS_REDIRECT_FROM_LAST_SMS,
  REMINDERS_REDIRECT_FROM_WEB_PUSH,
  REMINDERS_REDIRECT_FROM_LAST_WEB_PUSH,
} from './tracking';
import { CHECKLIST_REMINDER } from '../../../../LoginForm/entryPoints';
import { isNativeApp } from '../../../../../core/util/device';

const getUrl = (utmCodes: any, userProfileId: any) => {
  const basePath = '/account/home';
  const directPath = isNativeApp() ? '' : `/${userProfileId}/get-care`;

  return `${basePath}${directPath}${utmCodes}`;
};

// jscs:disable
export const handleRedirectToReminders = (userProfileId: any, timesSent: any) => {
  analyticsTrackEvent(REMINDERS_ACTION, {
    timesSent,
    action: REMINDERS_REDIRECT_FROM_SMS,
  });
  const utmCodes = '?utm_source=consumer&utm_medium=sms&utm_campaign=reminder';
  return history.replace(getUrl(utmCodes, userProfileId));
};

export const handleRedirectToRemindersLastSms = (userProfileId: any) => {
  analyticsTrackEvent(REMINDERS_ACTION, {
    action: REMINDERS_REDIRECT_FROM_LAST_SMS,
  });
  const utmCodes = '?utm_source=consumer&utm_medium=sms&utm_campaign=reminder';
  return history.replace(getUrl(utmCodes, userProfileId));
};

export const handleRedirectToRemindersWebPush = (userProfileId: any, timesSent: any) => {
  analyticsTrackEvent(REMINDERS_ACTION, {
    timesSent,
    action: REMINDERS_REDIRECT_FROM_WEB_PUSH,
  });
  const utmCodes = `?utm_source=consumer&utm_medium=web_push&utm_campaign=reminder&ep=${CHECKLIST_REMINDER}`;
  return history.replace(getUrl(utmCodes, userProfileId));
};

export const handleRedirectToRemindersLastWebPush = (userProfileId: any) => {
  analyticsTrackEvent(REMINDERS_ACTION, {
    action: REMINDERS_REDIRECT_FROM_LAST_WEB_PUSH,
  });
  const utmCodes = '?utm_source=consumer&utm_medium=web_push&utm_campaign=reminder';
  return history.replace(getUrl(utmCodes, userProfileId));
};
